export default "__VITE_ASSET__C$nadvsH__"